import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Result} from "@domain/common/http/result";
import {environment} from "@environments/environment";
import {Tournee} from "@domain/Tournee/tournee";
import {FraisService} from "@components/frais/frais.service";
import {EtapeTournee} from "@domain/Tournee/etape-tournee";

/**
 * Service pour la gestion de la tournée
 */
@Injectable()
export class TourneeService {

    /**
     * Constructeur
     */
    constructor(private http: HttpClient, private fraisService: FraisService) {
    }

    /**
     * Chargement d'une tournée
     *
     * @param idTournee id de la tournee
     * @param idPrestation id de la prestation
     */
    load(idTournee: number, idPrestation: number): Observable<Result> {
        return this.http.get<Result>(
            `${environment.baseUrl}/controller/Tournee/getTournee/${idTournee}/${idPrestation}`);
    }

    /**
     * Sauvegarde la mémorisation de la liste
     *
     * @param tournee la tournée courante
     */
    saveMemorized(tournee: Tournee): Observable<Result> {
        return this.http.put<Result>(
            `${environment.baseUrl}/controller/Tournee/saveMemorizedTournee`
            ,tournee);
    }

    /**
     * Calcule la distance entre les localisations de départ et d'arrivée d'une étape et met à jour sa distance
     *
     * @param etape objet portant les localisations de départ/arrivée et la distance à mettre à jour
     * @param onError callback optionnel invoqué en cas d'échec du calcul (ex : affichage d'un toast côté composant)
     */
    findDistance(etape: EtapeTournee, onError?: () => void): void {
        this.fraisService.findDistance(etape.localisationDepart,etape.localisationArrivee,false)
            .subscribe({
                next: (distance: number) => {
                    //Mise à jour de la distance sur l'étape
                    etape.distance = distance;
                },
                error: () => {
                    //Pas de calcul possible on affecte la valeur par défaut
                    etape.distance = 0;
                    onError?.();
                }
            });
    }
}